export default {
  cardOneTitle: '什麼是融資購買力',
  cardOneDesc1: '融資購買力是代表您可下單買賣股票的金額',
  cardOneDesc2:
    '融資購買力將您在盈寶的各市場股票資產、各貨幣基金和各貨幣現金折算相加减成為一個通用、統一的購買力。',
  cardOneTips: '備註：融資購買力只可買賣股票，暫不可直接認購IPO和買入基金',

  cardTwoTitle: '我的融資購買力',
  cardTwoSubTitle1: '融資購買力構成',
  cardTwoSubTitle2: '淨現金結餘折算',
  cardTwoSubTitle3: '貨幣在途現金折算',
  cardTwoSubTitle4: '可抵押市值折算',
  cardTwoSubTitle5: '融資購買力合計',
  hkCash: '港元淨現金結餘',
  usCash: '美元淨現金結餘',
  hkZtBalancePlus: '港元在途餘額+',
  usZtBalancePlus: '美元在途餘額+',
  hkHoldBalancePlus: '港元持倉餘額+',
  usHoldBalancePlus: '美元持倉餘額+',
  when: '當',
  mortgageMarketValue: '可抵押市值',
  financingAmount: '融資額度',
  usedBuyPower: '已用購買力',
  cashOnHold: '待買入',
  financingPurchasingPower: '融資購買力',
  netCash: '淨現金結餘',
  balancePlusMortgageMarketValue: '餘額+抵押市值',
  isMarketValueSmallTips: '融資購買力=（淨現金結餘）+（可抵押市值）+（餘額+抵押市值）-（已用購買力）',
  isMarketValueBigTips: '融資購買力=（淨現金結餘）+（融資額度）-（待買入）',

  cardThreeTitle: '融資購買力使用場景',
  cardThreeDesc: '用戶只有港股資產和港幣，沒有美元現金，想買入美股股票',
  cardThreeSubTitle1: '沒有融資購買力之前：',
  cardThreeSubDesc1: '用戶只能賣出港股並貨幣兌換成美元或者入金美元，買入美股',
  cardThreeSubTitle2: '有融資購買力之後：',
  cardThreeSubDesc2: '用戶可直接買入美股。因為盈寶會直接幫客戶把港股和港幣折算成美元買入美股。',

  cardFourTitle: '什麼是可抵押市值',
  cardFourDesc1: '可抵押市值代表客戶持倉的港股市值，在盈寶可抵押多少金額額外增加融資購買力。',
  cardFourDesc2: '案例：<br/>如您持倉10,000HKD市值的騰訊，騰訊抵押率為50%，港幣為0HKD，想買入4,000HKD小米。',
  cardFourDesc3: '則可抵押市值為 10,000*50%=5,000HKD',
  cardFourDesc4: '抵押出來的5,000HKD可用來買入小米。',

  cardFiveTitle: '為什麼可抵押市值很高融資購買力卻很少',
  cardFiveDesc1:
    '受融資額度限制，融資額度決定客戶的最高融資限額，當融資額度比較小的時候，哪怕持倉可抵押市值很高，所能融資的額度也是會受到限制。',
  cardFiveDesc2:
    '案例：用戶可抵押市值100萬HKD，但是融資額度只有10萬HKD在現金為0的情況下，客戶的融資購買力也是只有10萬，而非100萬。',

  cardSixTitle: '實際可買入金額為什麼會大於融資購買力',
  cardSixDesc1: '因為即將買入的股票也可繼續抵押釋放購買力。因此盈寶在計算時已經幫客戶進行循環抵押融資。',
  cardSixDesc2:
    '在循環購買力的加持下，比如客戶持有10,000HKD的融資購買力，買入抵押率75%的股票，那麼實際最大可買金額為10,000/（1-75%）=40000HKD的股票，即是可直接下單40,000的買入訂單。',

  cardSevenTitle: '如何知道有沒有使用融資以及如何還款',
  cardSevenDesc1: '在賬戶明細頁面查看“融資欠款”，如融資欠款>0，則代表您已使用融資;如融資欠款<0，則代表您沒有融資。',
  cardSevenDesc2: '在資產首頁-“融資”功能入口，也可查看融資欠款',
  cardSevenDesc3: '如何還款：您可存入對應欠款幣種的現金，或進行貨幣兌換。',
  cardSevenTips: '注意:IPO融資和股票抵押融資是有區分的，盈寶暫未打通使用融資購買力融資認購IPO',

  cardEightTitle: '融資利息什麼時候會扣款',
  cardEightDesc1: '融資利息是按照每天計算,在每個自然月最後一個交易日扣款。',
  cardEightDesc2: '客戶可在"融資"或"賬戶明細"查看預計利息,了解當前的利息情況。'
}
